/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './speciality-symptom-preferences.reducer';

export const SpecialitySymptomPreferencesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const specialitySymptomPreferencesEntity = useAppSelector(state => state.specialitySymptomPreferences.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="specialitySymptomPreferencesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.detail.title">SpecialitySymptomPreferences</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.id">Id</Translate>
            </span>
          </dt>
          <dd>{specialitySymptomPreferencesEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.active">Active</Translate>
            </span>
          </dt>
          <dd>{specialitySymptomPreferencesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{specialitySymptomPreferencesEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{specialitySymptomPreferencesEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{specialitySymptomPreferencesEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{specialitySymptomPreferencesEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{specialitySymptomPreferencesEntity.timestampEntry}</dd>
          <dt>
            <span id="aSymptom">
              <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.aSymptom">A Symptom</Translate>
            </span>
          </dt>
          <dd>{specialitySymptomPreferencesEntity.aSymptom ? 'true' : 'false'}</dd>
          <dt>
            <span id="aCondition">
              <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.aCondition">A Condition</Translate>
            </span>
          </dt>
          <dd>{specialitySymptomPreferencesEntity.aCondition ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.speciality">Speciality</Translate>
          </dt>
          <dd>{specialitySymptomPreferencesEntity.speciality ? specialitySymptomPreferencesEntity.speciality.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.symptom">Symptom</Translate>
          </dt>
          <dd>{specialitySymptomPreferencesEntity.symptom ? specialitySymptomPreferencesEntity.symptom.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.specialitySymptomPreferences.condition">Condition</Translate>
          </dt>
          <dd>{specialitySymptomPreferencesEntity.condition ? specialitySymptomPreferencesEntity.condition.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/speciality-symptom-preferences" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/speciality-symptom-preferences/${specialitySymptomPreferencesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SpecialitySymptomPreferencesDetail;
